<app-loader [Parent]="this"></app-loader>
<div [formGroup]="Form" *ngIf="FormLoaded">
  <app-pageheader [Parent]="this">
    <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()"></app-form-save-button>
    @if (!ModelIsNew) {
      <app-form-delete-button [Parent]="this" [Form]="Form" [ModelId]="ModelId" [Model]="Model"
        DeleteUrl="payments/transactionbreakdown/pricingmodes/" DeleteNavLink="/revenue/transactionbreakdown" Title="Pricing Mode" NameProperty="TargetType">
      </app-form-delete-button>
    }
  </app-pageheader>
  <div class="columns">
    <div class="column is-6">
      <article class="panel">
        <p class="panel-heading">Pricing Mode</p>
        <div class="panel-block is-block">
          <p class="mb-3">Controls whether amounts quoted for this entity type already include the organization's transaction fees (Inclusive), or fees should be added on top of the quoted amount (Exclusive). Entity types with no pricing mode configured default to Inclusive.</p>
          <app-field Label="Target Type">
            <div class="control select is-fullwidth">
              <select formControlName="TargetType">
                <option value="" disabled>Select a target type</option>
                @for (item of TargetTypes ?? []; track item.Name) {
                  <option value="{{item.Name}}">{{item.DisplayName}}</option>
                }
              </select>
              <app-validator [For]="Form.get('TargetType')"></app-validator>
            </div>
          </app-field>
          <app-field Label="Pricing Mode">
            <div class="control select is-fullwidth">
              <select formControlName="PricingMode">
                <option [ngValue]="0">Inclusive (quoted amount already includes fees)</option>
                <option [ngValue]="1">Exclusive (fees are added on top of the quoted amount)</option>
              </select>
            </div>
          </app-field>
        </div>
      </article>
    </div>
  </div>
</div>
